<template>
  <footer class="global-footer">
    <div class="container">
      <div class="row">
        <p>{{ $t('copyright') }} &copy; {{ currentYear }} - {{ $t('allRightsReserved') }}</p>
        <nav>
          <ul v-if="!isBookPage">
            <li v-for="(item, itemIndex) in getAgencyMenus.bookingPlatform.footerMenu" :key="itemIndex">
              <span v-if="item.link.startsWith('http')">
                <a :href="item.link" :title="item.title">{{item.title}}</a>
              </span>

              <span v-else>
                <router-link :to="`/${$i18n.locale}/` + item.link" :title="item.title">{{item.title}}</router-link>
              </span>
            </li>

            <li>
              <router-link :to="{ name: 'Login' }" title="Agents">Agents</router-link>
            </li>
          </ul>
        </nav>

        <div class="payment-methods">
          <p>{{ $t('paySafelyUsing') }}:</p>
          <ul>
            <li v-for="(method, methodIndex) in paymentMethods" :key="methodIndex">
              <img :src="`https://assets.totaltravel.io/img/footer/${method.img}.png`" :alt="method.name" :class="method.img" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GlobalFooter',

  data() {
    return {
      paymentMethods: [
        
        {
          name: 'Visa',
          img: 'logo-visa'
        },
        {
          name: 'Mastercard',
          img: 'logo-mastercard'
        },
        {
          name: 'American Express',
          img: 'logo-amex'
        },
        {
          name: 'Discover',
          img: 'logo-discover'
        },
        {
          name: 'Diners Club',
          img: 'logo-diners-club'
        },
        {
          name: 'JCB Global',
          img: 'logo-jcb'
        }
      ]
    }
  },

  methods: {
    getImgUrl: function(url) {
      return require('../assets/img/footer/' + url + '.png')
    },
  },

  computed: {
    ...mapGetters ([
      'getAgencyMenus'
    ]),

    isBookPage: function() {
      if (this.$route.path.includes('book') && !this.$route.path.includes('bookings')) {
        return true
      } else {
        return false
      }
    },

    currentYear: function() {
      let d = new Date();
      return d.getFullYear();
    }
  }
}
</script>